export default function Footer() {
  return (
    <footer className="w-full px-6 md:px-10 pb-6">
      <div className="max-w-7xl mx-auto bg-foreground-950 rounded-3xl px-8 md:px-16 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="text-3xl font-bold text-white font-heading">Stay Updated</h3>
            <p className="mt-3 text-sm text-white/50 font-body leading-relaxed max-w-xs">
              Get the latest Hipobuy Spreadsheet updates, new category additions, and shopping tips delivered to your inbox.
            </p>
            <form
              className="mt-8"
              data-readdy-form="true"
              action="https://readdy.ai/api/form/d9936l3558j8vijmgvpg"
              method="POST"
            >
              <div className="flex flex-col gap-3">
                <input
                  type="email"
                  name="email"
                  placeholder="Your email address"
                  required
                  className="w-full bg-transparent border-b border-white/20 pb-3 text-sm text-white placeholder:text-white/30 font-body outline-none focus:border-white/50 transition-colors"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="form-anti-spam-field"
                />
                <button
                  type="submit"
                  className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-white text-foreground-900 text-sm font-semibold hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap w-fit"
                >
                  Subscribe
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </form>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white/60 font-body tracking-wider uppercase">Navigate</h4>
            <nav className="mt-6 flex flex-col gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-white/50 hover:text-white/80 transition-colors underline decoration-white/20 font-body">Hipobuy Sheet</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-white/50 hover:text-white/80 transition-colors underline decoration-white/20 font-body">Buy It Now</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-white/50 hover:text-white/80 transition-colors underline decoration-white/20 font-body">All Categories</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-white/50 hover:text-white/80 transition-colors underline decoration-white/20 font-body">Spreadsheet Guides</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white/60 font-body tracking-wider uppercase">Contact</h4>
            <div className="mt-6 flex flex-col gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-white/50 hover:text-white/80 transition-colors font-body">kaspreadsheet.com</a>
              <span className="text-sm text-white/30 font-body">Hipobuy Spreadsheet Hub</span>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-white/40 hover:text-white/70 transition-colors underline font-body">Privacy</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-white/40 hover:text-white/70 transition-colors underline font-body">Terms</a>
          </div>
          <p className="text-xs text-white/30 font-body">
            &copy; {new Date().getFullYear()} hipobuyspread.hair. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-white/40 hover:text-white/70 transition-colors underline font-body">Twitter</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-white/40 hover:text-white/70 transition-colors underline font-body">Reddit</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-white/40 hover:text-white/70 transition-colors underline font-body">Pinterest</a>
          </div>
        </div>
      </div>
    </footer>
  );
}